import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Switch, Toast, Button, Dialog, Tabs, InfiniteScroll } from 'antd-mobile-v5';
import { toWxMiniProgram } from '../../api/createHttpRequest';
import { withRouter } from 'react-router-dom';
import MedicalConsult from '../component/medicalConsult';
import PrizeActivity from '../component/prizeActivity';
import NoInventory from '../component/noInventory';
import InConstruction from '../component/inConstruction';
import styles from './index.module.scss';
import icon_search from '../../static/images_doctor/tool_introdce_search.png';
import icon_search_clear from '../../static/images_medicalLive/search_clear.png';
import DoctorAvatar from '../../static/images_cso/doctor_avatar.png';
import scan_qr from '../../static/images_cso/scan_qr.png';
import file from '../../static/images_cso/file.png';
import write from '../../static/images_cso/write.png';
import right_arrow_white from '../../static/images_cso/right_arrow_white.svg';
import cure_suggestion from '../../static/images_cso/cure_suggestion.png';
import collect_suggestion from '../../static/images_cso/collect_suggestion.png';
import icon_qr_suggestion from '../../static/images_cso/icon_qr_suggestion.png';
// import covid19 from '../../static/images_cso/covid_19.png';
import prescription_icon from '../../static/images_cso/prescription_icon.png';
import right_arrow from '../../static/images_cso/right_arrow.png';
import right_arrow_home from '../../static/images_cso/right_arrow_home.png';
import no_cure_suggest from '../../static/images_cso/no_cure_suggest.png';
import home_circle_full from '../../static/images_cso/home_circle_full.png';
import special_selected from '../../static/images_cso/search/special_selected.png';
import excellent_selected from '../../static/images_cso/search/excellent_selected.png';
import star from '../../static/images_cso/search/star.png';
import un_star from '../../static/images_cso/search/un_star.png';
import tab_star from '../../static/images_cso/search/tab_star.png';
import tab_special_selected from '../../static/images_cso/search/tab_special_selected.png';
import tab_excellent_selected from '../../static/images_cso/search/tab_excellent_selected.png';
import abroad_medicine from '../../static/images_cso/search/abroad_medicine.png';
import to_file from '../../static/images_cso/search/to_file.png';
import home_arrow_up from '../../static/images_cso/search/home_arrow_up.png';
import is_selected from '../../static/images_cso/search/is_selected.png';
import utils from '../../utils/utils';

const api = new ApiCore();

let delayExcute:any = null;
let scrollDicretion = 'down';
let lastScrollTop = 0;

const CSOHome = (props: any) => {

    const [doctorInfo, setDoctorInfo] = useState<any>();
    const [projects, setProjects] = useState<any>([]);
    const [recordStatistics, setRecordStatistics] = useState<any>({});
    const [successRateArr, setSuccessRateArr] = useState<any>([]);
    const [project, setProject] = useState<any>({});
    const [activeKey, setActiveKey] = useState('');
    const [suggestReady, setSuggestReady] = useState(false);
    const [modules, setModules] = useState<any>([]);
    const [treatmentPlans, setTreatmentPlans] = useState<any>([]);
    const [selfPlan, setSelfPlan] = useState<any>({});
    const [suggestTabs, setSuggestTabs] = useState<any>([]);
    const [suggestList, setSuggestList] = useState<any>([]);
    const [searchKey, setSearchKey] = useState<any>(null);
    const [activeSuggestIndex, setActiveSuggestIndex] = useState<any>(0);
    const [cureHasMore, setCureHasMore] = useState(true);
    const [cureCurPage, setCureCurPage] = useState(0);
    const [curePageSize, setCurePageSize] = useState(10);
    const [cureTotal, setCureTotal] = useState<any>(null);
    
    const [collectReady, setCollectReady] = useState(false);
    const [collectTabs, setCollectTabs] = useState<any>([]);
    const [collectList, setCollectList] = useState<any>([]);
    const [activeCollectIndex, setActiveCollectIndex] = useState<any>(0);
    const [hasMore, setHasMore] = useState(true);
    const [curPage, setCurPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState<any>(null);

    const [showMedicalConsult, setShowMedicalConsult] = useState<any>(false);
    const [hasMedicalConsult, setHasMedicalConsult] = useState<any>(false);
    const [activityInfo, setActivityInfo] = useState<any>({});
    const [departments, setDepartments] = useState<any>([]);
    const [showDepartments, setShowDepartments] = useState<any>(false);
    const [selectedDepartment, setSelectedDepartment] = useState<any>('全部领域');
    const noInventoryRef = useRef<any>();
    const noCollectInventoryRef = useRef<any>();
    const inConstruction = useRef<any>();
    const medicalConsult = useRef<any>();
    const prizeActivity = useRef<any>();

    useEffect(() => {
        document.title = '惠每良医工作室';
        initData();
        initEvent();
        return () => {
        }
    }, [])

    const initEvent = () => {
        let scrollDom = document.getElementById('cso_doctor_home_content');
        scrollDom?.addEventListener("scroll", (e) => {
            // @ts-ignore
            let nowScrollTop:any = e?.target?.scrollTop;
            sessionStorage.setItem('cso_doctor_home_scroll_top', nowScrollTop);
            // if (nowScrollTop > lastScrollTop) {
            //     scrollDicretion = 'down';
            // } else {
            //     scrollDicretion = 'up';
            // }
            // let targetDom = document.getElementById('cso_doctor_home_collect_list');
            // lastScrollTop = nowScrollTop;
            // let tRect:any = targetDom?.getBoundingClientRect();
            // if (tRect.top < 10) {
            //     targetDom?.classList.add('cso_doctor_home_collect_list');
            //     // @ts-ignore
            //     // scrollDom?.style?.color = "#333333";
            //     // @ts-ignore
            //     scrollDom?.classList.add('cso_doctor_home_content_scroll_not');
            // } else {
            //     targetDom?.classList.remove('cso_doctor_home_collect_list');
            // }
        });
    }

    // 搜索标题变化
    const titleInput = (event: any) => {
        setSearchKey(event.target.value);
    }

    // 清除输入内容
    const clearInput = () => {
        setSearchKey('');
    }

    useEffect(() => {
        if (doctorInfo && doctorInfo.code) {
            toShowMedicalConsult();
        }
        return () => {
        }
    }, [doctorInfo])

    // 防抖搜索
    useEffect(() => {
        clearTimeout(delayExcute);
        if (searchKey !== null) {
            delayExcute = setTimeout(() => {
                searchSuggestList();
            }, 300);
        }
    }, [searchKey])

    const initData = async () => {
        const sourceType = sessionStorage.getItem('CSODoctorSourceType');
        const projectCode = sessionStorage.getItem('CSODoctorProjectCode');
        // getInfo().then(data => {
            let data = await getInfo();
            let needSupplierRegister = true;
            if (!data.projects) {
                needSupplierRegister = true;
            } else if (data.projects) {
                // 查看是否需要注册供应商
                (data.projects || []).some((item: any) => {
                    if (item.code == projectCode) {
                        // 表示已经注册
                        needSupplierRegister = false;
                        return true;
                    } else {
                        needSupplierRegister = true;
                    }
                });
            }
            // 没有项目时注册以及更新
            if (projectCode && needSupplierRegister) {
                const registerResult = await api.getSupplierRegister({
                    projectCode: projectCode,
                    invitationId: sessionStorage.getItem('CSODoctorSource') || ''
                    // PG2023020900001 众生 PG2023031700001 小惠
                });
                // 更新用户信息
                data = await getInfo();
            }
            setDoctorInfo(data);
            sessionStorage.setItem('cso_doctor_info', JSON.stringify(data));
            const _projects = data.projects || [];
            setProjects(_projects);
            // 新冠只配一个
            let _projects0 = (_projects && _projects[0]) || '';
            setProject(_projects0);
            setActiveKey(_projects0.code)
            // api.getCsoHomeModule({
            //     mainCode: _projects0.mainCode,
            //     version: _projects0.mainVersion
            // }
            let tenantCode = localStorage.getItem('tenantCode') || '';
            api.getDoctorHomePage(tenantCode).then((res: any) => {
                if (res.code == 0) {
                    const _data = res.data || {};
                    let _content = _data.content || '';
                    if (_content) {
                        _content = JSON.parse(_content);
                        const _modules = _content.modules;
                        setModules(_modules);
                        const hasStatitcs = _modules.find((val: any) => val.type == 'PrescriptionStatistics');
                        const hasMedicalConsult = _modules.find((val: any) => val.type == 'MedicalConsult');
                        const hasCureSuggestion = _modules.find((val: any) => val.type == 'CureSuggestion');
                        const hasCureCollect = _modules.find((val: any) => val.type == 'CureCollectSelectSuggestion');
                        setHasMedicalConsult(hasMedicalConsult);
                        hasStatitcs  && api.getDoctorRecordStatistics({
                            projectCode: _projects0
                        }).then((res: any) => {
                            if (res.code == 0) {
                                setRecordStatistics(res.data || {});
                                let rate = res.data.inquiryCreateNum == 0 ? 0 : (res.data.signInNum / res.data.inquiryCreateNum);
                                let rateNumber = Math.floor(rate * 10);
                                let rate100 = rate * 100;
                                let num_0_9 = 0;
                                if (rate100 < 10) {
                                    num_0_9 = rate100;
                                } else {
                                    num_0_9 = ((rate100 / 10) - Math.floor(rate100 / 10)) * 10;
                                }
                                let rateArray = new Array(10).fill({
                                    rateNumber: rateNumber,
                                    rate100: rate100,
                                    num_0_9: num_0_9
                                });
                                setSuccessRateArr(rateArray);
                            }
                        });
                        (hasCureSuggestion || hasCureCollect) && initEnums(hasCureSuggestion, hasCureCollect);
                        hasCureCollect && initSelfPlan();
                        extraActivity();
                    }
                }
            })
        // });
    }

    const initEnums = (hasCureSuggestion: boolean, hasCureCollect: boolean) => {
        api.getTreatmentPlanTypeEnums().then((res: any) => {
            // 滚动到之前浏览的地方
            setTimeout(() => {
                let scrollDom = document.getElementById('cso_doctor_home_content');
                let scroll_top = sessionStorage.getItem('cso_doctor_home_scroll_top');
                if (scroll_top) {
                    scrollDom?.scrollTo({ top: parseFloat(scroll_top), behavior: 'smooth'});
                }
            }, 500)
            if (res.code == 0) {
                const data = res.data || [];
                setTreatmentPlans(data);
                const mSuggestTab = [{
                    name: '常用建议'
                }, ...data];
                let mCollectTab = [{
                    name: '我的收藏',
                    isCollect: true
                }, {
                    name: '甄选产品',
                    pickType: 1
                }, {
                    name: '优选产品',
                    pickType: 2
                }, {
                    name: '境外药品',
                    channelType: 1
                }, ...data];
                let collectIndex: any = sessionStorage.getItem('cso_home_doctor_collect_index');
                setActiveCollectIndex(collectIndex || 0);
                let suggestIndex: any = sessionStorage.getItem('cso_home_doctor_suggest_index');
                setActiveSuggestIndex(suggestIndex || 0);
                mCollectTab = mCollectTab.map((v: any, i) => {
                    if (collectIndex == i) {
                        return {
                            ...v,
                            selected: true
                        }
                    } else {
                        return {
                            ...v,
                            selected: false
                        }
                    }
                });
                hasCureSuggestion && setSuggestTabs(mSuggestTab);
                hasCureSuggestion && getSuggestList((suggestIndex || 0), mSuggestTab);
                let departmentCode: any = sessionStorage.getItem('cso_home_doctor_collect_department_code');
                hasCureCollect && setCollectTabs(mCollectTab);
                hasCureCollect && api.getPropertiesList('department').then((res: any) => {
                    if (res.code == 0) {
                        let data = res.data || [];
                        data.unshift({
                            code: '',
                            name: "全部领域",
                            selected: true
                        });
                        if (departmentCode) {
                            data = data.map((v: any) => {
                                if (v.code == departmentCode) {
                                    setSelectedDepartment(v.name);
                                    return {
                                        ...v,
                                        selected: true
                                    }
                                } else {
                                    return {
                                        ...v,
                                        selected: false
                                    }
                                }
                            })
                        }
                        setDepartments(data);
                        hasCureCollect && getCollectList((collectIndex || 0), mCollectTab, data)

                    }
                })
            }
        })
    }

    const initSelfPlan = () => {
        api.getPlanSelfList({}).then((res: any) => {
            if (res.code == 0) {
                if (res?.data?.rows) {
                    if (res?.data?.rows[0]) {
                        setSelfPlan(res?.data?.rows[0]);
                    }
                }
            }
        });
    }

    const departmentsChange = (val: any) => {
        let mDepartments = departments.map((v: any) => {
            if (v.code == val.code) {
                return {
                    ...v,
                    selected: true
                }
            } else {
                return {
                    ...v,
                    selected: false
                }
            }
        });
        setDepartments(mDepartments)
        setTimeout(() => {
            setShowDepartments(false);
            getCollectList(activeCollectIndex, collectTabs, mDepartments);
        }, 300) 
    }

    const extraActivity = async () => {
        let token = sessionStorage.getItem('token');
        if (token) {
            let _token: any = {};
            try {
                _token = JSON.parse(token);
            } catch (error) {
                _token = {};
            }
            if (_token && _token.tenantConfig && _token.tenantConfig.enableDuanWuActivity) {
                const record =  await api.actionRecordQuery({ type: 'DuanWu' });
                if (!record.data) {
                    api.queryActivity({
                        type: 'DuanWu'
                    }).then((res: any) => {
                        if (res.code == 0) {
                            // setActivityInfo({
                            //     code: 'DW001'
                            // });
                            if (res.data && res.data.length > 0) {
                                setActivityInfo(res.data || {});
                            }
                        }
                    })
                }
            }
        }
    }

    const getInfo = () => {
        return new Promise<any>((resolve) => {
            api.getCsoDoctorInfo().then((res: any) => {
                if (res.code == 0) {
                    const _data = res.data || {};
                    resolve(_data);
                }
            });
        });
    }

    const addPatient = () => {
        props.history.push(`/cso/doctor/doctorInfo?doctorCode=${doctorInfo.code}&projectCode=${project.code || ''}`);
    }

    const toCovid = async () => {
        let auditState = doctorInfo.state;
        let isGuest = false;
        let token = sessionStorage.getItem('token');
        if (token) {
            let tokens = JSON.parse(token);
            if (tokens.isGuest) {
                isGuest = true;
            }
        }
        if (isGuest) {
            // 游客
            const result = await Dialog.confirm({
                content: '您尚未授权登录，请前往授权登录后使用',
            })
            if (result) {
                // 确定
                toWxMiniProgram('/pages/index/index?needLogin=1');
            }
        } else if (!isGuest &&(auditState !== 1 && auditState !== 4) ) {
            const result = await Dialog.confirm({
                content: '您尚有个人信息未完善，请先补全个人信息后使用',
            })
            if (result) {
                // 确定
                toWxMiniProgram('/pages/csoComplete/csoComplete');
            } else {
                // 取消
            }
        } else {
            const params = {
                code: project.code
            }
            const medicineRes: any = await api.getPlanRecommendDetail(params);
            if (medicineRes.code == 0) {
                props.history.push(`/cso/doctor/covidSuggest`);
            } else if (medicineRes.code == 70010100) {
                // 70010100 -> 暂无推荐的药品！
                noInventoryRef.current.toShow();
            } else {
                Toast.show(medicineRes.message);
            }
        }
    }

    const toMoreCure = async () => {
        let auditState = doctorInfo.state;
        let isGuest = false;
        let token = sessionStorage.getItem('token');
        if (token) {
            let tokens = JSON.parse(token);
            if (tokens.isGuest) {
                isGuest = true;
            }
        }
        if (isGuest) {
            // 游客
            const result = await Dialog.confirm({
                content: '您尚未授权登录，请前往授权登录后使用',
            })
            if (result) {
                // 确定
                toWxMiniProgram('/pages/index/index?needLogin=1');
            }
        } else if (!isGuest &&(auditState !== 1 && auditState !== 4)) {
            const result = await Dialog.confirm({
                content: '您尚有个人信息未完善，请先补全个人信息后使用',
            })
            if (result) {
                // 确定
                toWxMiniProgram('/pages/csoComplete/csoComplete');
            } else {
                // 取消
            }
        } else {
            props.history.push(`/cso/doctor/moreCureSuggest`);
        }
    }

    const toAuthLogin = () => {
        toWxMiniProgram('/pages/index/index?needLogin=1');
    }

    const toVerify = () => {
        toWxMiniProgram('/pages/csoComplete/csoComplete');
    }

    const liveClick = async(val: any) => {
        let auditState = doctorInfo.state;
        let isGuest = false;
        let token = sessionStorage.getItem('token');
        if (token) {
            let tokens = JSON.parse(token);
            if (tokens.isGuest) {
                isGuest = true;
            }
        }
        if (isGuest) {
            // 游客
            const result = await Dialog.confirm({
                content: '您尚未授权登录，请前往授权登录后使用',
            })
            if (result) {
                // 确定
                toWxMiniProgram('/pages/index/index?needLogin=1');
            }
        } else if (!isGuest &&(auditState !== 1 && auditState !== 4)) {
            const result = await Dialog.confirm({
                content: '您尚有个人信息未完善，请先补全个人信息后使用',
            })
            if (result) {
                // 确定
                toWxMiniProgram('/pages/csoComplete/csoComplete');
            } else {
                // 取消
            }
        } else {
            window.location.href = val.link;
        }
    }

    const statisticsRender = (val: any, key: number) => {
        const info = val.attributes || {};
        return (<div className={styles.head_count} key={key + Math.random()}>
            <div className={styles.h_c_1}>
                <div>已注册</div>
                <div> <span className={styles.count}>{recordStatistics.registerNum || 0}</span> 人</div>
            </div>
            <div className={styles.h_c_2}>
                <div>已建议</div>
                <div> <span className={styles.count}>{recordStatistics.inquiryCreateNum || 0}</span> 次</div>
            </div>
            {/* <div className={styles.h_c_3}>
                <div> <span className={styles.count}>{recordStatistics.paySuccessNum || 0}</span> 次</div>
                <div>已支付</div>
            </div> */}
            {/* <div className={styles.h_c_4}>
                <div> <span className={styles.count}>{recordStatistics.signInNum || 0}</span> 次</div>
                <div>已收货</div>
            </div> */}
              <div className={`${styles.head_count_item} ${styles.progress}`}>
                <div className={styles.head_count_item_t}>荐方成功率</div>
                {/* <div> <span className={styles.count}>{recordStatistics.signInNum || 0}</span> <span>次</span></div> */}
                <div> 
                    {
                        successRateArr.map((val: any, key: number) => (
                            <div key={key} className={`${styles.progress_un_active}`}>
                                {/* <div className={`${key < val.rateNumber ? styles.progress_active: ''}  ${key == val.rateNumber ? styles.not_full : ''}`} 
                                    style={{ width: `${( key < val.rateNumber ? '100' : (val.num_0_9 / 10) * 100)}%`, height: '100%'}}
                                >
                                </div>
                                {
                                   (key == val.rateNumber) && val.num_0_9 && !isNaN(val.num_0_9) && val.num_0_9 >= 1 && val.num_0_9 < 10 &&
                                    <img src={require(`../../static/images_cso/full_circle/home_circle_full_${Math.floor(val.num_0_9)}.png`).default} />
                                } */}
                                {
                                    key < val.rateNumber &&
                                    <div className={`${styles.progress_active}`} 
                                    >
                                    </div>
                                }
                                {
                                    key == val.rateNumber &&
                                    <div className={styles.progress_half}  style={{ width: `${( (val.num_0_9 / 10) * 100)}%`, height: '100%'}}>
                                        <img src={home_circle_full} />
                                    </div>
                                }
                            </div>
                        ))
                    }
                    
                </div>
            </div>
        </div>);
    }

    const suggestionRender = (val: any, key: number) => {
        const info = val.attributes || {};
        return (<div className={styles.suggestion} key={key + Math.random()}>
            <div className={styles.s_l} onClick={toCovid}>
                <div>
                    <div>新冠治疗建议</div>
                    <div className={styles.to_look}> 
                        <div>立即查看</div> 
                        <img src={right_arrow} alt="" />
                    </div>
                </div>
                <img className={styles.s_l_icon} src={write} alt="" />
            </div>
            <div className={styles.gap_line}></div>
            <div className={styles.s_r} onClick={toMoreCure}>
                <div>
                    <div>更多治疗建议</div>
                    <div className={styles.to_look}> 
                        <div>查看更多</div> 
                        <img src={right_arrow} alt="" />
                    </div>
                </div>
                <img className={styles.s_r_icon} src={file} alt="" />
            </div>
        </div>);
    }

    const liverLinkRender = (val: any, key: number) => {
        const info = val.attributes || {};
        const url = info.background;
        return (<div className={styles.live_banner} key={key + Math.random()}>
            <img src={url} onClick={() => { liveClick(info)}} alt="" />
        </div>)
    }
    
    const toolsRender = (val: any, key: number) => {
        const info = val.attributes || {};
        return (
            <div className={styles.cure_tool} key={key + Math.random()} onClick={()=> {  }}>
                <div className={styles.title}>
                    <img src={info.icon} className={styles.c_l_t}  alt="" />
                    <span>{info.title}</span>
                </div>
                <div className={styles.c_l_img_wrap}>
                    {
                        info.list.map((val: any, key: number) => <img key={key} src={val.background} onClick={() => { toolsActive(val) }} alt="" />)
                    }
                </div>
            </div>
        )
    }

    const CureSuggestionRender = (val: any, index: number) => {
        return (
        <div className={`${styles.cure_suggestion} ${styles.in_cure_suggestion}`} key={index}>
            <div className={styles.cure_suggestion_top_img} >
                <img src={cure_suggestion} alt="" />
            </div>
            <div className={styles.cure_suggestion_content} >
                <div className={styles.head_b}>
                    <div className={styles.search_wrap}>
                            <div className={`${styles.tool_introduce_head}`}>
                                <div className={styles.search_head}>
                                    <div className={styles.search}>
                                        <img className={styles.search_img} src={icon_search} alt="" />
                                        <input type="text" placeholder="输入处方名称，药品名称，适应症进行搜索" value={searchKey} onChange={(event) => { titleInput(event) }} />
                                        {
                                            searchKey &&
                                            <img className={`${styles.search_img_clear}`} src={icon_search_clear} alt="" onClick={ () => { clearInput() }} />
                                        }
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
                <div className={styles.search_content}>
                    <div className={styles.search_content_l}>
                         {
                            searchKey ?
                            <div className={`${styles.active}`}>
                               相关建议
                            </div>
                            :
                            suggestTabs.map((val: any, key: number) => (
                                <div key={key} className={`${key == activeSuggestIndex ? styles.active: styles.un_active}`} onClick={() => { onSuggestChange(key) }}>
                                    {val.name}
                                </div>
                            ))
                         }
                    </div>
                    <div className={styles.search_content_r}>
                        {
                            suggestReady && suggestList.length == 0 &&
                            <div className={styles.search_no_content_wrap}>
                                <img src={no_cure_suggest} alt="" />
                                <div>
                                    暂无相关治疗建议
                                </div>
                            </div>
                        }
                        {
                         suggestList.map((val: any, key: number) => (
                            <div key={key} className={`${styles.suggest_item}`} onClick={() => { onCureSuggestClick(val) }}>
                                <img className={styles.search_content_r_1} src={prescription_icon} alt="" />
                                <div  className={styles.search_content_r_2}>
                                    <div className={styles.search_content_r_2_t}>{val.title}</div>
                                    <div className={styles.search_content_r_2_b}>{val.remark}</div>
                                </div>
                                <img className={styles.search_content_r_3} src={right_arrow_home} alt="" />
                            </div>
                        ))
                        }
                        {
                            suggestList.length > 0 &&
                            <InfiniteScroll loadMore={cureLoadMore} hasMore={cureHasMore} >{''}</InfiniteScroll>
                        }
                    </div>
                </div>
            </div>
        </div>)
    }

    const CureCollectSuggestionRender = (val: any, index: number) => {
        return (
        <div className={`${styles.cure_suggestion} ${styles.collect_suggestion}`} key={index} style={{ marginTop: '16px' }} id="cso_doctor_home_collect_list">
            <div className={styles.cure_suggestion_top_img} >
                <img src={collect_suggestion} alt="" />
                {
                    selfPlan.code &&
                    <div className={styles.icon_qr_suggestion} onClick={() => {
                        onCureSuggestClick(selfPlan, false, '/cso/doctor/multiMedicineDetail');
                    }}>
                        <img src={icon_qr_suggestion} alt="" />
                        <span>甄选产品包</span>
                    </div>
                }
            </div>
            <div className={styles.cure_suggestion_content} >
                <div className={styles.head_b}>
                    <div className={styles.search_wrap}>
                            <div className={`${styles.tool_introduce_head}`}>
                                <div className={styles.search_head}>
                                    <div className={styles.search} onClick={ () => { props.history.push('/cso/doctor/search') }}>
                                        <img className={styles.search_img} src={icon_search} alt="" />
                                        <input type="text" placeholder="请输入商品名或通用名进行搜索" />
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
                <div className={styles.search_content}>
                    <div className={styles.search_content_l}>
                         {
                            collectTabs.map((val: any, key: number) => (
                                <div key={key} className={`${key == activeCollectIndex ? styles.active: styles.un_active}`} onClick={() => { onCollectChange(key) }}>
                                    {
                                        key == 0 &&
                                        <img className={styles.tab_star} src={tab_star} alt="" />
                                    }
                                    {
                                        key == 1 &&
                                        <img className={styles.tab_special_selected} src={tab_special_selected} alt="" />
                                    }
                                    {
                                        key == 2 &&
                                        <img className={styles.tab_special_selected} src={tab_excellent_selected} alt="" />
                                    }
                                    {
                                        key == 3 &&
                                        <img className={styles.tab_special_selected} src={abroad_medicine} alt="" />
                                    }
                                    <span className={styles.name}>{val.name}</span>
                                </div>
                            ))
                         }
                    </div>
                    <div className={styles.search_content_r}>
                        <div className={styles.all_department} onClick={ () => { setShowDepartments(!showDepartments) }}>
                            <div>{selectedDepartment}</div>
                            <img className={`${showDepartments ? '' : styles.reverse} ${styles.arrow}`} src={home_arrow_up} alt="" />
                        </div>
                        {
                            collectReady && collectList.length == 0 &&
                            <div className={styles.search_no_content_wrap}>
                                <img src={no_cure_suggest} alt="" />
                                <div>
                                    暂无相关结果
                                </div>
                            </div>
                        }
                        {
                         collectList.map((val: any, key: number) => (
                            <div key={key} className={`${styles.collect_item}`}>
                                <div className={styles.search_content_collect_r_1}>
                                    <img className={styles.search_content_r_1_1}  src={val.icon || prescription_icon} alt="" />
                                    {
                                        val.channelType == 1 && 
                                        <img className={styles.search_content_r_1_1_b} src={abroad_medicine} alt="" />
                                    }
                                </div>
                                <div  className={styles.search_content_r_2}>
                                    <div className={styles.search_content_r_2_t}>
                                        {
                                            // val.isPick && 
                                            val.pickType == 1 && 
                                            <img className={styles.special_selected} src={special_selected} alt="" />
                                        }
                                        {
                                            val.pickType == 2 && 
                                            <img className={styles.special_selected} src={excellent_selected} alt="" />
                                        }
                                        <span className={styles.title}>{val.drugName}</span>
                                    </div>
                                    <div className={`${styles.search_content_r_2_b} ${styles.line_1}`}>{val.manufacturerName}</div>
                                    <div className={styles.search_content_r_2_b_b}>
                                        {/* <img className={styles.to_file} src={to_file} alt="" /> */}
                                        <div className={styles.medicine_price}>
                                            <span className={styles.unit}>¥</span>
                                            <span className={styles.price}>{val.price}</span>
                                        </div>
                                        <div className={styles.to_detail} onClick={() => { onCureSuggestClick(val, true) }}>查看详情</div>
                                    </div>
                                </div>
                                <img className={`${styles.search_content_r_3} ${styles.search_content_r_3_layout}`} src={val.isCollect ? star : un_star} alt="" onClick={(e) => { starChange(e, key)}} />
                            </div>
                        ))
                        }
                        {
                            collectList.length > 0 &&
                            <InfiniteScroll loadMore={loadMore} hasMore={hasMore} >{''}</InfiniteScroll>
                        }
                    </div>
                    {
                        showDepartments && 
                        <>
                            <div className={styles.department_expand}>
                                {
                                    departments && departments.map((val: any) => (
                                        <div className={`${val.selected ? styles.active : ''}`} onClick={() => { departmentsChange(val)}}>
                                            <div>{val.name}</div>
                                            {
                                                val.selected &&
                                                <img src={is_selected} alt="" />
                                            }
                                        </div>
                                    ))
                                }
                            </div>
                            <div className={styles.department_cover}>
                            </div>
                        </>
                    }
                </div>
            </div>
        </div>)
    }
    
    const toolsActive = async(val: any) => {
        let auditState = doctorInfo.state;
        let isGuest = false;
        let token = sessionStorage.getItem('token');
        if (token) {
            let tokens = JSON.parse(token);
            if (tokens.isGuest) {
                isGuest = true;
            }
        }
        if ((val.link.indexOf('/cso/doctor/guide') == -1 && val.link.indexOf('/cso/doctor/cure') == -1) && (isGuest || (auditState !== 1 && auditState !== 4))) {
            // 资料下载和医学问卷 未认证或者游客登录
            if (isGuest) {
                // 游客
                const result = await Dialog.confirm({
                    content: '您尚未授权登录，请前往授权登录后使用',
                })
                if (result) {
                    // 确定
                    toWxMiniProgram('/pages/index/index?needLogin=1');
                }
            } else {
                // 尚未认证
                const result = await Dialog.confirm({
                    content: '您尚有个人信息未完善，请先补全个人信息后使用',
                })
                if (result) {
                    // 确定
                    toWxMiniProgram('/pages/csoComplete/csoComplete');
                }
            }
        } else if (val.link.indexOf('/cso/doctor/cure') >= 0) {
            props.history.push('/cso/doctor/cure');
        } else if (val.link.indexOf('/cso/doctor/guide') >= 0) {
            props.history.push('/cso/doctor/guide');
        } else if (val.background.indexOf('questionnaire.png') >= 0) {
            inConstruction.current.toShow();
        } else {
            window.location.href = val.link;
        }
    }

    const onSuggestChange = (index: number) => {
        setActiveSuggestIndex(index);
        sessionStorage.setItem('cso_home_doctor_suggest_index', index + '');
        setSearchKey(null);
        getSuggestList(index);
    }

    const onCollectChange = (index: number) => {
        setActiveCollectIndex(index);
        sessionStorage.setItem('cso_home_doctor_collect_index', index + '');
        getCollectList(index);
    }

    // 初始化以及切换左侧处方建议菜单时触发
    const getSuggestList = (index: number, mSuggestTab?: Array<any>) => {
        const item = (mSuggestTab || suggestTabs)[index];
        if (item) {
            setSuggestReady(false);
            setCureCurPage(1)
            let params = {};
            if (item.code) {
                params = {
                    content: '',
                    type: item.code,
                    projectCode: project.code,
                    pageSize: curePageSize
                }
            } else {
                params = {
                    content: '',
                    // projectCode: project.code,
                    isCommon: true,
                    pageSize: curePageSize
                }
            }
            // api.getTreatmentPlanList(params).then((res: any)=> {
            api.getTreatmentPlanListPage(params).then((res: any)=> {
                if (res.code == 0) {
                    if (1 * curePageSize >= res.data?.total) {
                        setCureHasMore(false);
                    } else {
                        setCureHasMore(true);
                    }
                    setCureTotal(res.data?.total); 
                    setSuggestReady(true);
                    // setSuggestList(res.data || []);
                    setSuggestList(res.data?.rows || []);
                }
            })
        }
    }

    const searchSuggestList = () => {
        const item = suggestTabs[activeSuggestIndex];
        if (item) {
            setSuggestReady(false);
            setCureCurPage(1)
            api.getTreatmentPlanList({
                content: searchKey,
                type: item.code,
                projectCode: project.code,
                page: 1,
                pageSize: curePageSize
            }).then((res: any)=> {
                if (res.code == 0) {
                    setCureTotal(res.data?.total);
                    setSuggestReady(true);
                    setSuggestList(res.data || []);
                }
            })
        }
    }

    const getCureData = () => {
        return new Promise<any>((resolve, reject) => {
            // if (cureTotal !== null && cureCurPage * curePageSize >= cureTotal) {
            //     setCureHasMore(false);
            //     resolve([]);
            // }
            let _curCurePage = cureCurPage;
            _curCurePage++;
            setCureCurPage(_curCurePage)
            const item = suggestTabs[activeSuggestIndex];
            if (item) {
                setSuggestReady(false);
                let params = {};
                if (item.code) {
                    params = {
                        content: '',
                        type: item.code,
                        projectCode: project.code,
                        pageSize: curePageSize
                    }
                } else {
                    params = {
                        content: '',
                        // projectCode: project.code,
                        isCommon: true,
                        pageSize: curePageSize
                    }
                }
                api.getTreatmentPlanListPage(params).then((res: any) => {
                    if (res.code == 0) {
                        setCureTotal(res.data?.total)
                        if (_curCurePage * curePageSize >= res.data?.total) {
                            setCureHasMore(false);
                        }
                        resolve(res.data?.rows);
                    }
                })
            }
        })
    }
    
    async function cureLoadMore() {
        const append = await getCureData();
        setSuggestList((val: any) => [...val, ...append]);
        setSuggestReady(true);
    }

    const getCollectList = (index: number, mCollectTab?: Array<any>, mDepartments?: Array<any>) => {
        const item = (mCollectTab || collectTabs)[index];
        let mmDepartments = mDepartments || departments;
        if (item) {
            setCollectReady(false);
            setCurPage(1)
            const params: any = {
                type: item.code,
                // isPick: item.isPick,
                pickType: item.pickType,
                channelType: item.channelType,
                isCollect: item.isCollect,
                projectCode: project.code,
                page: 1,
                pageSize: pageSize
            }
            if (mmDepartments) {
                let item = mmDepartments.filter((v: any) => v.selected);
                if (item[0]) {
                    if (item[0].code) {
                        params.propertyCodes = [item[0].code]; 
                    }
                    sessionStorage.setItem('cso_home_doctor_collect_department_code', item[0].code);
                    setSelectedDepartment(item[0].name);
                }
            }
            api.getPlanPage(params).then((res: any)=> {
                if (res.code == 0) {
                    if (1 * pageSize >= res.data?.total) {
                        setHasMore(false);
                    } else {
                        setHasMore(true);
                    }
                    setTotal(res.data?.total); 
                    setCollectReady(true);
                    setCollectList(res.data?.rows || []);
                }
            })
        }
    }

    const getData = () => {
        return new Promise<any>((resolve, reject) => {
            // if (total !== null && curPage * pageSize >= total) {
            //     setHasMore(false);
            //     resolve([]);
            // }
            let _curPage = curPage;
            _curPage++;
            setCurPage(_curPage)
            const item = collectTabs[activeCollectIndex];
            let mmDepartments = departments;
            const params: any = {
                type: item.code,
                // isPick: item.isPick,
                pickType: item.pickType,
                channelType: item.channelType,
                isCollect: item.isCollect,
                projectCode: project.code,
                page: _curPage,
                pageSize: pageSize
            }
            if (mmDepartments) {
                let item = mmDepartments.filter((v: any) => v.selected);
                if (item[0]) {
                    if (item[0].code) {
                        params.propertyCodes = [item[0].code]; 
                    }
                }
            }
            api.getPlanPage(params).then((res: any) => {
                if (res.code == 0) {
                    setTotal(res.data?.total)
                    if (_curPage * pageSize >= res.data?.total) {
                        setHasMore(false);
                    }
                    resolve(res.data?.rows);
                }
            })
        })
    }
    
    async function loadMore() {
        const append = await getData();
        setCollectList((val: any) => [...val, ...append]);
        setCollectReady(true);
    }
    
    // 收藏与取消收藏 
    const starChange = (e: any, index: any) => {
        e.stopPropagation();
        let _collectList = collectList.map((v: any) => v);
        _collectList[index].isCollect = !collectList[index].isCollect;
        setCollectList(_collectList);
        // 更新
        api.getPlanCollect({
            treatmentPlanCode: _collectList[index].code
        });
    }

    const onCureSuggestClick = async (val: any, needAliasName?: any, toUrl?: any) => {
        let auditState = doctorInfo.state;
        let isGuest = false;
        let token = sessionStorage.getItem('token');
        if (token) {
            let tokens = JSON.parse(token);
            if (tokens.isGuest) {
                isGuest = true;
            }
        }
        if (isGuest) {
            // 游客
            const result = await Dialog.confirm({
                content: '您尚未授权登录，请前往授权登录后使用',
            })
            if (result) {
                // 确定
                toWxMiniProgram('/pages/index/index?needLogin=1');
            }
        } else if (!isGuest &&(auditState !== 1 && auditState !== 4) ) {
            const result = await Dialog.confirm({
                content: '您尚有个人信息未完善，请先补全个人信息后使用',
            })
            if (result) {
                // 确定
                toWxMiniProgram('/pages/csoComplete/csoComplete');
            } else {
                // 取消
            }
        } else {
            const params: any = {
                code: val.code
            }
            const medicineRes: any = await api.getPlanDetail(params);
            if (medicineRes.code == 0) {
                let jumpUrl = toUrl ? toUrl : '/cso/doctor/covidSuggest';
                props.history.push(`${jumpUrl}?code=${val.code}&projectCode=${project.code || ''}&needAliasName=${needAliasName || ''}&channelType=${val.channelType || ''}`);
            } else if (medicineRes.code == 70010100) {
                // 70010100 -> 暂无推荐的药品！
                if (!needAliasName) {
                    noInventoryRef.current.toShow();
                } else {
                    noCollectInventoryRef.current.toShow();
                }
            } else {
                Toast.show(medicineRes.message);
            }
        }
    }

    // 展示医疗顾问二维码
    const toShowMedicalConsult = () => {
        const auditState = doctorInfo?.state;
        const isValidDoctor = (auditState == 1 || auditState == 4);
        const doctorReady = (doctorInfo && Object.keys(doctorInfo).length > 0);
        const medicalConsultShowed = localStorage.getItem('CSO_Medical_Consult');
        if (doctorReady && isValidDoctor && !medicalConsultShowed) {
            setShowMedicalConsult(true);
            // medicalConsult.current.toShow(); -> 组件未加载完毕
            localStorage.setItem('CSO_Medical_Consult', 'true');
        }
    }

    let auditState = doctorInfo?.state;
    let isGuest = false;
    let token = sessionStorage.getItem('token');
    if (token) {
        let tokens = JSON.parse(token);
        if (tokens.isGuest) {
            isGuest = true;
        }
    }

    // 是否是合格的医生
    const isValidDoctor = (auditState == 1 || auditState == 4);
    const doctorReady = (doctorInfo && Object.keys(doctorInfo).length > 0);
    return (
        <div className={styles.CSO_home_content} id="cso_doctor_home_content">
            <div className={styles.content}>
                <div className={styles.head}>
                    <div className={styles.heads}>
                        <img className={styles.h_l} src={DoctorAvatar} alt="" />
                        <>
                            { doctorReady &&
                                <>
                                    {
                                        isGuest ?
                                        <div className={styles.h_m}>
                                            <div className={styles.h_m_t}>
                                                <div className={styles.h_m_t_l}>游客登录</div>
                                            </div>
                                            <div className={styles.h_m_b} onClick={toAuthLogin}>
                                                <div className={styles.h_m_b_l_t}>点击前往完成授权登录</div>
                                                <img className={styles.h_m_b_r_img} src={right_arrow_white} alt="" />
                                            </div>
                                        </div>
                                        :
                                        isValidDoctor ?
                                        <div className={`${styles.h_m} ${doctorInfo.identityType == 5 ? `${styles.h_m_center}` : ''}`}>
                                            <div className={styles.h_m_t}>
                                                <div className={styles.h_m_t_l}>{doctorInfo.identityType != 5 ? doctorInfo.name : '欢迎您入驻惠每良医工作室！'}</div>
                                                {
                                                    doctorInfo.identityType != 4 && doctorInfo.identityType != 5 && doctorInfo.title &&
                                                    <div className={styles.h_m_t_r}>{doctorInfo.title}</div>
                                                }
                                            </div>
                                            {
                                                (!doctorInfo.identityType || doctorInfo.identityType == 1 || doctorInfo.identityType == 3) ?
                                                <div className={styles.h_m_b}>
                                                    <div className={styles.h_m_b_l}>{doctorInfo.institution}</div>
                                                    { 
                                                        doctorInfo.dept && 
                                                        <>
                                                            <div className={styles.h_m_b_m}></div>
                                                            <div className={styles.h_m_b_r}>{doctorInfo.dept}</div>
                                                        </>
                                                    }
                                                </div> 
                                                :
                                                doctorInfo.identityType != 5 ?
                                                <div className={styles.h_m_b}>
                                                    <div className={styles.h_m_b_l}>{doctorInfo.code.replace( /(\d{3})\d{4}(\d{4})/, "$1 **** $2")}</div>
                                                </div>
                                                :
                                                null
                                            }
                                        </div>
                                        :
                                        <div className={styles.h_m}>
                                            <div className={styles.h_m_t}>
                                                <div className={styles.h_m_t_l}>暂未认证</div>
                                            </div>
                                            <div className={styles.h_m_b} onClick={toVerify}>
                                                <div className={styles.h_m_b_l_t}>点击前往完成身份认证</div>
                                                <img className={styles.h_m_b_r_img} src={right_arrow_white} alt="" />
                                            </div>
                                        </div>
                                    }
                                </>
                            }
                        </>
                        {
                            false && isValidDoctor &&
                            <div className={styles.h_r} onClick={addPatient}>
                                <img className={styles.scan_qr} src={scan_qr} alt="" />
                                <div>扫码添</div>
                                <div>加患者</div>
                            </div>
                        }
                    </div>
                </div>
                {
                    modules && modules.map((val: any, key: number) => {
                        if (val.type == 'PrescriptionStatistics') {
                            return statisticsRender(val, key);
                        } 
                        else if (val.type == 'PrescriptionSuggestions') {
                            return suggestionRender(val, key);
                        } else if (val.type == 'LiveLink') {
                            return liverLinkRender(val, key);
                        } else if (val.type == 'ToolsWorkBench') {
                            return toolsRender(val, key);
                        } else if (val.type == 'CureSuggestion') {
                            return CureSuggestionRender(val, key);
                        } else if (val.type == 'CureCollectSelectSuggestion') {
                            return CureCollectSuggestionRender(val, key);
                        }
                    })
                }
                <div className={styles.in_bottom}></div>
                <NoInventory ref={noInventoryRef}></NoInventory>
                <NoInventory ref={noCollectInventoryRef} text='暂无库存，请选择其他药品'></NoInventory>
                <InConstruction ref={inConstruction}></InConstruction>
                {
                    hasMedicalConsult && showMedicalConsult &&
                    <MedicalConsult ref={medicalConsult}></MedicalConsult>
                }
                {
                    activityInfo && Object.keys(activityInfo).length > 0 &&
                    <PrizeActivity ref={prizeActivity} activityInfo={activityInfo}></PrizeActivity>
                }
            </div>
        </div>
    )
}

export default withRouter(CSOHome);